import { Typography } from "@mui/material"
import { getObjectProperty } from "app/tools/common"
import { DspSingleSelect } from "dsp/components/DspSingleSelect"
import { checkTouched, isTouched as hasBeenTouched } from "form/tools/validation"
import { Field, FieldProps } from "formik"
import React from "react"

interface IFieldSelectDspProps {
  fieldName: string
  disabled?: boolean
  required?: boolean
  error?: string
  sx?: any
}

export const FieldSelectDsp = React.memo(
  ({ disabled, error, fieldName, required, sx }: IFieldSelectDspProps): JSX.Element => (
    <Field name={fieldName}>
      {({ form: { touched, values, setFieldValue } }: FieldProps) => {
        const isTouched: boolean = hasBeenTouched(touched, fieldName)
        let dspId = getObjectProperty(values, fieldName)
        return (
          <>
            <DspSingleSelect
              id={fieldName}
              required={required}
              disabled={disabled}
              error={isTouched ? error || "" : ""}
              defaultSelectedDspId={dspId}
              onChange={newDsp => {
                if (!isTouched) {
                  checkTouched(touched, fieldName)
                }
                setFieldValue(fieldName, newDsp ? newDsp.id : null)
              }}
              onBlur={() => {
                if (!isTouched) {
                  checkTouched(touched, fieldName)
                  setFieldValue(fieldName, dspId)
                }
              }}
              sx={sx}
            />
            {error && (
              <Typography id={`${fieldName}-error`} color="error" fontSize=".75rem" sx={{ mt: "-.5rem", ml: "1rem" }}>
                {error}
              </Typography>
            )}
          </>
        )
      }}
    </Field>
  )
)
